export function getPublicSlugPrefix() {
  return ''
}

export function buildPublicPath(slug) {
  return `/${slug}`
}

export function buildPublicUrl(slug) {
  const path = buildPublicPath(slug)
  const origin = typeof window !== 'undefined' && window.location ? window.location.origin : ''
  return `${origin}${path}`
}
